<template>
    <div v-if="loaded">
        <design-2021-questionnaire-edit-title-component
            :questionnaire-in="questionnaire"></design-2021-questionnaire-edit-title-component>

        <div class="questionnaire-edit">
            <div class="row">
                <div class="col-12 col-md-4 col-xl-3">
                    <div class="apprentice-simple-card">
                        <div class="generic-settings">
                            <div class="component-title">
                                <h5 class="title">Algemeen</h5>
                            </div>

                            <div class="linked">
                                <b-form-group
                                    class="liked-setting-group"
                                    label-cols="12"
                                    label-cols-lg="10"
                                    content-cols="12"
                                    content-cols-lg="2"
                                    label="Vragenlijst koppelen aan project"
                                    label-for="linked-setting-toggle">
                                    <b-form-checkbox
                                        class="linked-toggle-setting"
                                        id="linked-setting-toggle"
                                        v-model="linked"
                                        switch
                                        @change="attachQuestionnaire">
                                    </b-form-checkbox>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                    <design-2021-questionnaire-edit-nav-component
                        :sections-in="questionnaire.sections"
                        @selected-questionnaire="changeSelectedQuestionnaire($event)">
                    </design-2021-questionnaire-edit-nav-component>
                </div>

                <div class="col-12 col-md-8 col-xl-9">
                    <design-2021-questionnaire-edit-questionnaire-component
                        :questionnaire-in="questionnaire"></design-2021-questionnaire-edit-questionnaire-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import { ords } from '../../app';

export default {
    name: 'design-2021-questionnaire-edit-component',
    props: ['questionnaireIn', 'groupIn'],
    components: { draggable },
    data() {
        return {
            questionnaire: {},
            toggledSection: '',
            loaded: false,
            selectedQuestionnaireId: null,
            linked: false,
        };
    },
    methods: {
        changeSelectedQuestionnaire(id) {
            this.selectedQuestionnaireId = id;
        },

        toggleSection(sectionId) {
            const sectionTag = `accordion-section-${sectionId}`;

            if (this.toggledSection === '' && this.toggledSection !== sectionTag) {
                this.$root.$emit('bv::toggle::collapse', sectionTag);
            }
        },

        attachQuestionnaire() {
            const data = {
                id: this.questionnaireIn.id,
            };

            this.alert.saving();
            this.axios.post(this.routes.questionnaireProjectToggle(this.groupIn.id), data).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
    mounted() {
        if (!this.loaded) {
            ords.use('questionnaire').add(this.questionnaireIn);

            ords.use('questionnaire')
                .with('sections', (sectionsCallback) => {
                    sectionsCallback.with('questions');
                })
                .find(this.questionnaire.id)
                .subscribe((questionnaire) => {
                    this.questionnaire = questionnaire;
                });

            this.linked = this.questionnaireIn.group !== null;

            this.loaded = true;
        }
    },
};
</script>

<style scoped lang="scss">
.ghost {
    background-color: darken($secondary-background-color, 25%);
}

.questionnaire-sections-nav {
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.questionnaire-section {
    .component-title {
        justify-content: flex-start;
        align-items: center;
        padding: map-get($grid-gutter-spacing, 'fifteen');
        margin-bottom: 0;
        color: $primary;
        background-color: $white;
        border-radius: 4px;

        .drag-handle {
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
        }
    }

    .questionnaire-questions-list {
        list-style: none;
        padding-left: 0;

        li {
            &:not(:last-child) {
                .questionnaire-question-nav-link {
                    border-bottom: 3px dotted $border-color;
                }
            }
        }

        .questionnaire-question-nav-link {
            display: flex;
            flex-direction: row;
            align-items: baseline;
            color: $text-color;
            padding: 8px 20px 8px 42px;

            .drag-handle {
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
            }
        }
    }
}

.empty-questionnaire-list {
    margin-bottom: 51px;
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .questionnaire-sections-nav {
        margin-bottom: 0;
    }
}
</style>
